/**
 * @description Proxy for global app properties.
 * The original properties reside in /public/app-properties.js so that they can be updated post-deployment like a properties file.
 * While the original properties reside outside /src, they cannot be directly imported as a module and have to be imported
 * in production run-time via index.html, but they are not directly available to unit test environment, hence the purpose
 * of this proxy is to allow the app properties be indirectly mocked in unit-test run-time environment.
 */

/* global GeneralSettings, FeatureToggles */
module.exports = {
  generalSettings:
    typeof GeneralSettings == "undefined" ? null : new GeneralSettings(),
  featureToggles:
    typeof FeatureToggles == "undefined" ? null : new FeatureToggles()
};



// WEBPACK FOOTER //
// ./src/properties/AppPropertiesProxy.js